import { render, staticRenderFns } from "./ProductLifecycle.vue?vue&type=template&id=590a4a28&scoped=true&"
import script from "./ProductLifecycle.vue?vue&type=script&lang=js&"
export * from "./ProductLifecycle.vue?vue&type=script&lang=js&"
import style0 from "./ProductLifecycle.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ProductLifecycle.vue?vue&type=style&index=1&id=590a4a28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "590a4a28",
  null
  
)

export default component.exports